module.exports = __webpack_public_path__ + "media/spinner-wheel-ticks.0e158e0e.mp3";